<template>
    <div class="xcard">
      <h3 class="text-center my-0"> Menu de Oferta academica. </h3>
      <hr class="mt-1"/> 

      <v-row class="justify-center">
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-row class="justify-center">
            <v-col 
              v-if="ispermitido"
              cols="12" >
              <template>
                <v-card class="mx-auto green darken-1 white--text" max-width="284" @click="reporteOpen('oferta_autoria_sel')">
                  <!-- <v-img
                    src="https://static.vecteezy.com/system/resources/previews/009/840/575/non_2x/wise-owl-in-graduation-cap-cute-cartoon-owl-vector.jpg"
                    height="150px"></v-img> -->
      
                  <v-card-title > Seleccionar proyectos </v-card-title>
      
                  <v-card-subtitle> Solicitar apertura de programas </v-card-subtitle>
                </v-card>
              </template>
            </v-col> 

            <v-col  
              v-if="ispermitido_regular"
              cols="12" >
              <template>
                <v-card class="mx-auto blue darken-1 white--text" max-width="284" @click="reporteOpen('oferta_autoria')">
                  <!-- <v-img
                    src="https://static.vecteezy.com/system/resources/previews/010/640/230/non_2x/wise-owl-in-graduation-cap-cute-cartoon-owl-vector.jpg"
                    height="150px"></v-img> -->
      
                  <v-card-title> Gestionar </v-card-title>
      
                  <v-card-subtitle> Aprobar y/o rechazar seleccionados </v-card-subtitle>
                </v-card>
              </template>
            </v-col>

            <v-col  
              v-if="ispermitido_regular"
              cols="12" >
              <template>
                <v-card class="mx-auto orange darken-1 white--text" max-width="284" @click="ofertaOpen()">
                  <!-- <v-img
                    src="https://static.vecteezy.com/system/resources/previews/010/640/230/non_2x/wise-owl-in-graduation-cap-cute-cartoon-owl-vector.jpg"
                    height="150px"></v-img> -->
      
                  <v-card-title> Lista oficial </v-card-title>
      
                  <v-card-subtitle> publicacion de la lista oficial </v-card-subtitle>
                </v-card>
              </template>
            </v-col> 

            <v-col 
              v-if="ispermitido_regular"
              cols="12" >
              <template>
                <v-card class="mx-auto purple darken-1 white--text" max-width="284" @click="reporteOpen('oferta_regularizar')">
                  <!-- <v-img
                    src="https://static.vecteezy.com/system/resources/previews/010/640/230/non_2x/wise-owl-in-graduation-cap-cute-cartoon-owl-vector.jpg"
                    height="150px"></v-img> -->
      
                  <v-card-title> Regularizar manual </v-card-title>
      
                  <v-card-subtitle> Visibilidad y estado en oferta. </v-card-subtitle>
                </v-card>
              </template>
            </v-col>
      
      
          </v-row>
        </v-col>
      </v-row>

      
    </div>
  </template>
  
  <script>
    export default {
      data() {
        return {
          estudiantes: [],
          ispermitido_general: false,
          ispermitido_regular: false,
          ispermitido: false,
        };
      },
      watch: {},
      components: {},
      methods: {
        ofertaOpen() {
          const u = this.$store.state.CARGO.sede.unidad_negocio; 
          
          if(u == 1) this.$router.push({ name: 'oferta_oficial_esam' });
          else this.$router.push({ name: 'oferta_oficial_dbs' });
        },
        reporteOpen(url) {
          this.$router.push({ name: url });
        },
        openlink(url) {
          window.location.href = url;
        },
      },
      mounted() {
        this.ispermitido_general = this.$store.state.CARGO.id == 1 || this.$store.state.CARGO.id == 2 || this.$store.state.CARGO.id == 3 || this.$store.state.CARGO.id == 5;
        this.ispermitido = this.$store.state.CARGO.id == 1 || this.$store.state.CARGO.id == 2 || this.$store.state.CARGO.id == 3 || this.$store.state.CARGO.id == 5 || this.$store.state.CARGO.id == 6 || this.$store.state.CARGO.id == 7 || this.$store.state.CARGO.id == 8 || this.$store.state.CARGO.id == 11 || this.$store.state.CARGO.id == 12 || this.$store.state.CARGO.id == 13;
        this.ispermitido_regular = this.$store.state.CARGO.id == 1 || this.$store.state.CARGO.id == 5 || this.$store.state.CARGO.id == 6;
      },
    };
  </script>
  